import './styles/Pagination.scss';

import { Dropdown } from '@whistler-ui/k2/components/Dropdown';
import { useClassHelper } from '@whistler-ui/k2/hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { componentName } from './constants';

interface Props {
  pageSize: number;
  handleSetPage: (pageSize: number, pageIndex: number) => void;
  pageSizes: number[];
  isInfinite?: boolean;
}

export const PageSizeDropdown = ({
  pageSize,
  handleSetPage,
  pageSizes,
  isInfinite,
}: Props) => {
  const c = useClassHelper(componentName);
  const { t } = useTranslation();

  return (
    <label className={c('__pagination--dropdown')}>
      {t('pagination_rows')}
      <Dropdown.Native
        name="pageSize"
        classes={{ container: c('__dropdown') }}
        value={`${pageSize}`}
        onChange={e => {
          const value = parseInt(e.target.value, 10);
          handleSetPage(value, 0);
        }}
        data-cy="pagination-page-size-dropdown"
      >
        {pageSizes.map((size, i, arr) => {
          if (isInfinite && size === arr[arr.length - 1]) {
            return null;
          }

          return (
            <option
              key={`${size}-${i}`}
              value={size}
              data-cy={`pagination-page-option-${size}`}
            >
              {size === arr[arr.length - 1] ? t('all') : size}
            </option>
          );
        })}
      </Dropdown.Native>
    </label>
  );
};
